// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file_mainWrapper__1\\+qMS {
  height: -moz-fit-content;
  height: fit-content;
  padding: 0 10px;
}

.file_formWrapper__xbSLM {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-y: scroll;
}

.file_registrationTitle__\\+hpMx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  max-width: 1080px;
}

.file_registrationConfigRoot__W3xLs {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}




.file_labelAndButtonWrapper__M0iw\\+ {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
}

.file_titleWrapper__jhTTO {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.file_checkboxWraper__U\\+\\+8r {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  gap: 8px;
}

.file_labelCheckBox__rEV40 {
  font-size: 14px;
  font-weight: 500;
}

.file_labelAndErrorWrapper__5b3o4 {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.file_orgTitleMain__siURg {
  font-weight: 600;
}

@media screen and (max-width: 600px) {
  .file_label-and-error-wrapper__\\+u5QR {
    margin-top: 10px;
  }
}

.file_subjectBlockConfigRoot__Sx3L2 {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
}

.file_blockConfigRoot__AwWky {
  background-color: #fff;
  padding-top: 30px;
  gap: 10px;
  width: 100%;
}

.file_buttonBlock__8zELi {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  margin-bottom: 16px;
}

.file_buttonConfigRoot__8N7sI {
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.file_formAddButton__qL9zv {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.file_formAddButton__qL9zv span {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.file_formAddButton__qL9zv img {
  flex-shrink: 0;
}

.file_formAddButton__qL9zv:hover {
  background-color: #f3f7f7;
}

.file_formButton__b6A1x {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 8px;
}

.file_inputField__dy6nl {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  width: 100%;
  min-width: 150px;
}

.file_inputField1__xcb-g {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 10px);
  width: 100%;
  min-width: 150px;
}

.file_inputField1__xcb-g .file_placeholder__9HK4A,
.file_inputField1__xcb-g input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 14px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.file_selectField__ZEOct {
  width: 100%;
  height: 48px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  padding: 8px;
  margin: 0;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
}

.file_inputField__dy6nl .file_placeholder__9HK4A,
.file_inputField__dy6nl input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

label {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.file_inputField__dy6nl input:hover {
  border-color: #8ea3b0;
}

.file_inputField__dy6nl input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.file_inputField__dy6nl input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.file_inputField__dy6nl input.file_-error__zsU4C {
  border-color: #ed1e1e;
}

.file_inputField1__xcb-g input:hover {
  border-color: #8ea3b0;
}

.file_inputField1__xcb-g input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.file_inputField1__xcb-g input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.file_inputField1__xcb-g input.file_-error__zsU4C {
  border-color: #ed1e1e;
}

.file_buttonForm__0aACE {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 8px);
}

.file_errorLabel__ZWlcA {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: rgb(249, 52, 30);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file_labelAndErrorWrapper__5b3o4 {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.file_customFileInput__cEmuK {
  position: relative;
  padding: 10px;
  border-radius: 5px;
  background: rgba(9, 172, 113, 0.05);
  border: 2px dashed rgba(29, 190, 166, 0.69);
  color: rgba(29, 190, 166, 0.69);
  font-weight: 300;
  width: 100%;
  height: 40px;
}

.file_customFileInput__cEmuK input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.file_fileName__L4ScO {
  padding: 9px;
  border-radius: 5px;
  background: rgba(255, 222, 217, 0.69);
  border: 2px dashed rgba(232, 55, 28, 0.69);
  color: rgba(29, 190, 166, 0.69);
  font-weight: 300;
  width: 100%;
  height: 40px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.file_fileNameUploaded__X3DT2 {
  padding: 9px;
  border-radius: 5px;
  background: rgba(209, 209, 209, 0.69);
  border: 2px dashed rgba(134, 134, 134, 0.69);
  color: rgba(29, 190, 166, 0.69);
  font-weight: 300;
  width: 100%;
  height: 40px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.file_inputField4__TdTUE {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  /* max-width: calc(33% - 10px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 20px);
  width: 100%;
  min-width: 150px;
  box-sizing: content-box;
}
.file_inputField3__5IuAI {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  /* max-width: calc(33% - 12px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  width: 100%;
  min-width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/FileUpload/file.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;;;;AAKA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;AAEzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".mainWrapper {\n  height: fit-content;\n  padding: 0 10px;\n}\n\n.formWrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  overflow-y: scroll;\n}\n\n.registrationTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 24px;\n  max-width: 1080px;\n}\n\n.registrationConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n}\n\n\n\n\n.labelAndButtonWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n  margin-bottom: 2px;\n  gap: 10px;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.checkboxWraper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  gap: 8px;\n}\n\n.labelCheckBox {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.orgTitleMain {\n  font-weight: 600;\n}\n\n@media screen and (max-width: 600px) {\n  .label-and-error-wrapper {\n    margin-top: 10px;\n  }\n}\n\n.subjectBlockConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.blockConfigRoot {\n  background-color: #fff;\n  padding-top: 30px;\n  gap: 10px;\n  width: 100%;\n}\n\n.buttonBlock {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  max-width: 100%;\n  margin-bottom: 16px;\n}\n\n.buttonConfigRoot {\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  padding: 10px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n}\n\n.formAddButton img {\n  flex-shrink: 0;\n}\n\n.formAddButton:hover {\n  background-color: #f3f7f7;\n}\n\n.formButton {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  gap: 8px;\n}\n\n.inputField {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(50% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField1 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(33% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField1 .placeholder,\n.inputField1 input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 14px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.selectField {\n  width: 100%;\n  height: 48px;\n  flex: 1 1 calc(50% - 10px);\n  padding: 8px;\n  margin: 0;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n}\n\n.inputField .placeholder,\n.inputField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\nlabel {\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n}\n\n.inputField input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField input.-error {\n  border-color: #ed1e1e;\n}\n\n.inputField1 input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField1 input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField1 input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField1 input.-error {\n  border-color: #ed1e1e;\n}\n\n.buttonForm {\n  flex: 1 1 calc(33% - 8px);\n}\n\n.errorLabel {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgb(249, 52, 30);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.customFileInput {\n  position: relative;\n  padding: 10px;\n  border-radius: 5px;\n  background: rgba(9, 172, 113, 0.05);\n  border: 2px dashed rgba(29, 190, 166, 0.69);\n  color: rgba(29, 190, 166, 0.69);\n  font-weight: 300;\n  width: 100%;\n  height: 40px;\n}\n\n.customFileInput input[type=\"file\"] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.fileName {\n  padding: 9px;\n  border-radius: 5px;\n  background: rgba(255, 222, 217, 0.69);\n  border: 2px dashed rgba(232, 55, 28, 0.69);\n  color: rgba(29, 190, 166, 0.69);\n  font-weight: 300;\n  width: 100%;\n  height: 40px;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.fileNameUploaded {\n  padding: 9px;\n  border-radius: 5px;\n  background: rgba(209, 209, 209, 0.69);\n  border: 2px dashed rgba(134, 134, 134, 0.69);\n  color: rgba(29, 190, 166, 0.69);\n  font-weight: 300;\n  width: 100%;\n  height: 40px;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.inputField4 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  /* max-width: calc(33% - 10px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(33% - 20px);\n  width: 100%;\n  min-width: 150px;\n  box-sizing: content-box;\n}\n.inputField3 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  /* max-width: calc(33% - 12px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  width: 100%;\n  min-width: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `file_mainWrapper__1+qMS`,
	"formWrapper": `file_formWrapper__xbSLM`,
	"registrationTitle": `file_registrationTitle__+hpMx`,
	"registrationConfigRoot": `file_registrationConfigRoot__W3xLs`,
	"labelAndButtonWrapper": `file_labelAndButtonWrapper__M0iw+`,
	"titleWrapper": `file_titleWrapper__jhTTO`,
	"checkboxWraper": `file_checkboxWraper__U++8r`,
	"labelCheckBox": `file_labelCheckBox__rEV40`,
	"labelAndErrorWrapper": `file_labelAndErrorWrapper__5b3o4`,
	"orgTitleMain": `file_orgTitleMain__siURg`,
	"label-and-error-wrapper": `file_label-and-error-wrapper__+u5QR`,
	"subjectBlockConfigRoot": `file_subjectBlockConfigRoot__Sx3L2`,
	"blockConfigRoot": `file_blockConfigRoot__AwWky`,
	"buttonBlock": `file_buttonBlock__8zELi`,
	"buttonConfigRoot": `file_buttonConfigRoot__8N7sI`,
	"formAddButton": `file_formAddButton__qL9zv`,
	"formButton": `file_formButton__b6A1x`,
	"inputField": `file_inputField__dy6nl`,
	"inputField1": `file_inputField1__xcb-g`,
	"placeholder": `file_placeholder__9HK4A`,
	"selectField": `file_selectField__ZEOct`,
	"-error": `file_-error__zsU4C`,
	"buttonForm": `file_buttonForm__0aACE`,
	"errorLabel": `file_errorLabel__ZWlcA`,
	"customFileInput": `file_customFileInput__cEmuK`,
	"fileName": `file_fileName__L4ScO`,
	"fileNameUploaded": `file_fileNameUploaded__X3DT2`,
	"inputField4": `file_inputField4__TdTUE`,
	"inputField3": `file_inputField3__5IuAI`
};
export default ___CSS_LOADER_EXPORT___;
